<script>
  import slick from 'slick-carousel';
  import $ from 'jquery';

  export default {
    props: {
      speed: {
        type: Number,
        default: 300
      }
    },
    data: () => ({

    }),
    computed: {

    },
    mounted() {
      this.makeSlick();
    },
    methods: {
      makeSlick() {
        $(this.$refs.wrapper).slick({
          fade: true,
          speed: this.speed,
          prevArrow: this.$refs.prevArrow,
          nextArrow: this.$refs.nextArrow
        });
      }
    }
  };
</script>
